import VueCookie from 'vue-cookie'
import { setLocalData, getUrlPara2, getMobile, getLocalData } from './utils'
import axios from 'axios'
import { Base64 } from 'js-base64'
import configObj from './config'
import { buildUrlAfterReturnDataConsumed } from './returnDataUrl'
import { clearOriginalReturnData, saveOriginalReturnData } from './return-data-context'
import { clearChannelH5Context, saveChannelH5Context } from './channel-h5-return'

function formatDateTime () {
  var date = new Date()
  var y = date.getFullYear()
  var m = date.getMonth() + 1
  m = m < 10 ? ('0' + m) : m
  var d = date.getDate()
  d = d < 10 ? ('0' + d) : d
  var h = date.getHours()
  var minute = date.getMinutes()
  var second = date.getSeconds()
  return y + m + d + h + minute + second
}

// 工厂模式：获取用户信息
export default class GetUserInfo {
  static whiteSNeedtores = ['/unicom/auth/result']
  static envs = {
    lth5: 'online', tlth5: 'test', ylth5: 'pre', tlth52: 'test'
  }

  // 获取search_info
  static getInstance = () => {
    const host = location.host
    if (['/unicom/login', '/unicom/ycMall/login'].some(tempPath => location.pathname.endsWith(tempPath)) || location.search.includes('jumpData=')) {
      GetUserInfo.isNeedClearCache = true
    }
    let returnData = ''
    const query = getUrlPara2(location.search)
    if (query.returnData) {
      if (query.returnData === 'fake') {
        returnData = ''
      } else {
        returnData = JSON.parse(Base64.decode(query.returnData))
      }
    }
    if (returnData && typeof returnData === 'object') {
      // 旧 Agent 核身恢复协议已停用，历史字段不得进入长期登录缓存或日志上报。
      delete returnData.resumeSessionId
    }
    GetUserInfo.h5Repay = !!query.h5Repay
    if (query.jumpData) {
      localStorage.setItem('h5LoginUrl', location.href)
    }
    const env = GetUserInfo.env = GetUserInfo.envs[host.replace(/^([a-z]+).+/g, '$1')]
    const { envParams, appInfo, extendParams } = returnData || {}
    GetUserInfo.logParams(env, returnData, appInfo, envParams, extendParams)
    return new GetUserInfo(returnData, appInfo, envParams, extendParams)
  }

  // 打印日志
  static logParams = (env, returnData, appInfo, envParams, extendParams) => {
    if (env !== 'online') {
      console.log('href: ', location.href)
      console.log('returnData: ', JSON.stringify(returnData))
      console.log('extendParams: ', JSON.stringify(extendParams))
      console.log('appInfo: ', JSON.stringify(appInfo))
      console.log('envParams: ', JSON.stringify(envParams))
    }
  }

  // 发送returnData
  static sendReturnData = (returnData, username, hostname) => {
    window.cacheReturnData = {
      type: 'new',
      username,
      returnData: returnData,
      environment: hostname
    }
    if (GetUserInfo.env !== 'online' && process.env.NODE_ENV === 'production' && returnData) {
      axios.post(configObj.userReturnDataUrl, window.cacheReturnData)
    }
  }

  // constructor
  constructor (returnData, appInfo, envParams, extendParams) {
    this.appInfo = appInfo
    if ((returnData || GetUserInfo.isNeedClearCache) && !GetUserInfo.whiteSNeedtores.some(tempPathname => location.pathname.endsWith(tempPathname))) {
      this.clearCache()
      this.saveCache(appInfo, envParams, extendParams)
    } else {
      this.getCache()
    }
    if (returnData) {
      // clearCache 完成后再保存完整上下文，保证本次联登数据不会被同一初始化流程清掉。
      saveOriginalReturnData(window.localStorage, returnData)
      this.hasReturnData = true
      GetUserInfo.sendReturnData(
        'returnData=' + Base64.encode(JSON.stringify(returnData)),
        this.logMobile,
        location.hostname
      )
    }
  }

  // 清除缓存
  clearCache = () => {
    // 新联登同时废弃旧 returnData 与渠道回跳 token；当前数据会在 clearCache 后重新保存。
    clearOriginalReturnData(window.localStorage)
    clearChannelH5Context()
    const cacheCurrentMode = localStorage.getItem('repay_current_mode')
    const noCleanKeys = ['h5LoginUrl', 'temp-video-record-events', 'temp-video-record-events-start-time', 'temp-video-record-mobile', 'video-record-events', 'video-record-events-start-time', 'video-record-mobile', 'video-record-page-scene-code', 'video-record-start-page', 'video-record-end-page', 'video-record-after-end-page', 'last-token']
    const noCleanKeysData = noCleanKeys.reduce((data, key) => {
      data[key] = localStorage.getItem(key)
      return data
    }, {})
    if (!localStorage.getItem('localLock') && !location.search.includes('isFinishVideo=true')) localStorage.clear()
    localStorage.removeItem('localLock')
    cacheCurrentMode && localStorage.setItem('repay_current_mode', cacheCurrentMode)
    Object.keys(noCleanKeysData).forEach(key => {
      noCleanKeysData[key] && localStorage.setItem(key, noCleanKeysData[key])
    })
    VueCookie.delete('category')
    VueCookie.delete('irr')
    VueCookie.delete('userInfo')
    VueCookie.delete('extendParamsData')
    VueCookie.delete('appInfo')
    VueCookie.delete('envData')
    VueCookie.delete('authRepayPlan')
    VueCookie.delete('log-start-time')
    VueCookie.delete('is_half_sms')
  }

  // 获取旧缓存
  getCache = () => {
    const userInfo = getLocalData('userInfo') || {}
    this.setMobileInfo(userInfo.userName)
    this.lzCode = localStorage.getItem('lzCode')
    this.appInfo = JSON.parse(localStorage.getItem('appInfo'))
  }

  setMobileInfo = userName => {
    // 联登 userName 已加密：日志直接使用原值，业务字段按原逻辑解密。
    this.logMobile = userName
    this.mobile = getMobile(userName)
  }

  // 清除后保存缓存
  saveCache = (appInfo, envParams, extendParams) => {
    let category = ''
    let lzCode = ''
    const blackBox = formatDateTime() + Math.random().toString(36).substr(2)
    if (extendParams) {
      this.setMobileInfo(extendParams.userName)
      // 渠道回跳只缓存服务端签发的上下文，供借还款完成后安全解析返回地址。
      saveChannelH5Context(extendParams)
      this.lzCode = lzCode = extendParams.lzCode
      category = extendParams.category
      extendParams.token && localStorage.setItem('last-token', extendParams.token)
      setLocalData('userInfo', extendParams)
      setLocalData('extendParamsData', extendParams)
    }
    if (GetUserInfo.h5Repay) {
      localStorage.setItem('h5_repay', true)
      GetUserInfo.h5Repay = false
    }
    if (lzCode) {
      setLocalData('lzCode', lzCode)
    }
    localStorage.setItem('blackBox', blackBox)
    category && localStorage.setItem('category', category)
    if (appInfo) {
      setLocalData('appInfo', appInfo)
    }
    const envData = Base64.encode(
      JSON.stringify({ ...{ blackBox }, ...envParams })
    )
    setLocalData('envData', envData)
    setLocalData('log-start-time', new Date().toLocaleString())
    this.urlSearch = location.search.slice(1)
    // 登录上下文入缓存后移除敏感查询参数，其他业务 query 与 fragment 原样保留。
    window.history.replaceState(null, null, buildUrlAfterReturnDataConsumed(location))
  }
}
